import { render, staticRenderFns } from "./FcSystemActorAvatar.vue?vue&type=template&id=5f4a5a24"
import script from "./FcSystemActorAvatar.vue?vue&type=script&lang=js"
export * from "./FcSystemActorAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports